import { useEffect, useState } from "react";

/**
 * Returns true while the viewport is at most `maxWidth` px wide.
 *
 * Prefer `mediaPhone`/`mediaTablet` CSS; use this only when the component tree
 * or behaviour must change. Outside a browser it returns false (desktop layout).
 */
export function useMaxWidth(maxWidth: number): boolean {
	const query = `(max-width: ${maxWidth}px)`;
	const [matches, setMatches] = useState(() =>
		typeof window !== "undefined" && typeof window.matchMedia === "function"
			? window.matchMedia(query).matches
			: false,
	);

	useEffect(() => {
		if (typeof window === "undefined" || typeof window.matchMedia !== "function") return undefined;

		const media = window.matchMedia(query);
		const onChange = () => setMatches(media.matches);
		onChange();
		media.addEventListener("change", onChange);
		return () => media.removeEventListener("change", onChange);
	}, [query]);

	return matches;
}
